import { useId } from 'react';
import { COLOR_TEXT_PRIMARY_INVERSE } from '@alltrails/denali/tokens';

type TikTokProps = {
  className?: string;
  openInNewTab?: boolean;
  color?: string;
  noFollowSocials?: boolean;
};

export default function TikTokIcon({ className = '', openInNewTab = false, color = COLOR_TEXT_PRIMARY_INVERSE, noFollowSocials }: TikTokProps) {
  const titleId = useId();
  return (
    <a
      href="https://www.tiktok.com/@alltrails"
      target={openInNewTab ? '_blank' : '_self'}
      rel={`noreferrer${noFollowSocials ? ' nofollow' : ''}`}
      className={className}
      data-testid="TikTok-icon"
    >
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 24 24">
        <title id={titleId}>TikTok</title>
        <g fill="none" fillRule="evenodd">
          <g fill={color} fillRule="nonzero">
            <g>
              <g>
                <path d="M12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2ZM12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0Z" />
                <path d="M17.25 10.716V8.4904C16.2109 8.4904 15.418 8.2122 14.9063 7.67148C14.381 7.05437 14.0868 6.27288 14.0742 5.46159V5.30094L11.9766 5.25C11.9766 5.25 11.9766 5.34012 11.9766 5.46159V14.2894C11.9046 14.6838 11.7137 15.0466 11.4297 15.3287C11.1457 15.6108 10.7823 15.7988 10.3884 15.8672C9.99455 15.9355 9.58926 15.881 9.22725 15.7111C8.86523 15.5411 8.56394 15.2637 8.36403 14.9165C8.16412 14.5693 8.07523 14.169 8.10935 13.7695C8.14347 13.37 8.29897 12.9906 8.55484 12.6826C8.81072 12.3746 9.15466 12.1527 9.54022 12.047C9.92578 11.9412 10.3344 11.9567 10.7109 12.0913V9.93623C10.4914 9.90015 10.2693 9.8818 10.0469 9.88138C9.24648 9.88138 8.46406 10.1195 7.79855 10.5655C7.13305 11.0115 6.61435 11.6455 6.30805 12.3873C6.00175 13.129 5.92161 13.9452 6.07776 14.7326C6.23391 15.52 6.61934 16.2433 7.1853 16.8111C7.75127 17.3788 8.47235 17.7654 9.25737 17.922C10.0424 18.0786 10.8561 17.9982 11.5955 17.691C12.335 17.3838 12.9671 16.8635 13.4117 16.1959C13.8564 15.5284 14.0938 14.7435 14.0938 13.9407C14.0933 13.7743 14.0829 13.6082 14.0625 13.4431V9.85787C15.0163 10.4554 16.1261 10.7541 17.25 10.716Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
}
